import { stringDate } from "../utils/utilityFunctions";
import { showGlobalDialogError } from "../components/error";
import { apiClient } from "./apiClient.services";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const GetDashboardData = async (startDate, endDate) => {
	const { businessId } = getAuthData();
	const datetostring = stringDate([startDate, endDate]);

	if (datetostring[0] === 'Invalid date') {
		datetostring[0] = datetostring[1]
	}

	if (datetostring[1] === 'Invalid date') {
		datetostring[1] = datetostring[0]
	}
	try {
		return await apiClient(`/dashboard/overviews/seller/marketplace-overview?startDate=${datetostring[0]}&endDate=${datetostring[1]}${localStorage.getItem("businessId") ? `&businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
	}
}

export const GetAccountBalances = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/dashboard/overviews/seller/account-balances${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
	}
}